import React from 'react';
import { HashRouter, Switch, Route } from "react-router-dom";
import Secrity from './Secrity';
import Login from './Login';
import SeeFile from './Login/SeeFile';
import Mobile from './Mobile';
// import ErrorComp from './components/Empty';
import ExamIndex from "./pages/exam";
import ExamDetail from "./pages/exam/detail";
import Activity from "./pages/activity";
import ActivityDetail from "./pages/activity/detail";
import HomePage from "./pages/home";
import TestPage from './pages/test/online-test';
import ManmadeExam from './pages/test/manmade-exam';
import BeforeAnswer from './pages/test/BeforeAnswer';
import ExamResult from './pages/test/ExamResult';
import { sendUserSso } from './College/apis/public';
import './App.less';
import { message } from 'antd';
import ExamEnvFeedback from './pages/test/ExamEnvFeedback';
import ExamExpFeedback from './pages/test/ExamExpFeedback';
import ExamResultEmailNotice from './pages/test/ExamResultEmailNotice';


import ExamScoreFeedback from './pages/test/ExamScoreFeedback';
import { setPDFNetworkStreamFactory } from 'pdfjs-dist/types/src/display/api';
import { deepStrictEqual } from 'assert';
import { kStringMaxLength } from 'buffer';
import { isJsxOpeningLikeElement } from 'typescript';
import { kill } from 'process';

interface IProps { };

interface IState {
  isMobile: boolean,
};

class App extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isMobile: false, // 是否是移动端，默认 Pc端
    };
  }
  // 传递用户信息
  putUserInfo = (info: any) => {
    sendUserSso(info).then((res: any) => {
      if (res && res.code === 0) {
        const { profile } = res.data;
        let info = {
          id: profile.userId,
          crm_account_name: profile.realName,
          is_admin: profile.isAdmin,
          ...profile
        };
        window.localStorage.setItem('userinfo', JSON.stringify(info));
      } else {
        res && message.error(res.msg);
      }
    })
  }
  render() {
    const { isMobile } = this.state;
    const _window: any = window;
    const userinfo: any = _window && _window.userInfo;
    const currUserInfo = window.localStorage.getItem('userinfo');
    if (userinfo && !currUserInfo) {
      this.putUserInfo(userinfo);
    }
    return (
      <>
        <div className="qy_totolcent">
          <HashRouter>
            {
              (!isMobile) ?
                <Switch>
                  {/* <Route path="/home" component={HomePage}></Route> */}
                  <Route exact path="/" component={HomePage}></Route>
                  <Route path="/activity/:id" component={ActivityDetail}></Route>
                  <Route exact path="/activity" component={Activity}></Route>
                  <Route exact path="/exam" component={ExamIndex}></Route>
                  <Route path="/exam/:id" component={ExamDetail}></Route>
                  <Route path="/seefile/:url" component={SeeFile} />
                  <Route path="/login" component={Login}></Route>
                  <Route path="/manmade_exam_check/:type/:id/:examType" component={ManmadeExam}></Route>
                  <Route path="/manmade_exam_check/:type/:id" component={ManmadeExam}></Route>
                  <Route path="/enter_exam/:id" component={TestPage}></Route>
                  <Route path="/before_exam/:id" component={BeforeAnswer}></Route>
                  {/* <Route path="/exam_env_feedback/:id" component={ExamEnvFeedback}></Route> */}
                  <Route path="/exam_env_feedback/:id/:type" component={ExamEnvFeedback}></Route>
                  <Route path="/exam_exp_feedback/:id/:type" component={ExamExpFeedback}></Route>
                  <Route path="/exam_result_email_notice/:id/:type" component={ExamResultEmailNotice}></Route>
                  <Route path="/exam_score_feedback/:id" component={ExamScoreFeedback}></Route>
                  <Route path="/exam_result/:mark/:recordId/:examId" component={ExamResult}></Route>
                  {/* <Route path="/" component={Secrity}></Route> */}
                  <Route component={Secrity} />
                  {/* <Route component={ErrorComp}></Route> */}
                </Switch>
                :
                <Switch>
                  <Route path="/" component={Mobile}></Route>
                </Switch>
            }
          </HashRouter>
        </div>
        <div className="qy_footer">
          Copyright © 2020, QingCloud Technologies Corp. All Rights Reserved. 北京青云科技股份有限公司
        </div>
      </>
    );
  }
}

export default App;
